import React, { Component } from 'react';
import { BackArrow } from 'components/styles/Common.styled';
import { Navigate } from 'react-router-dom';
import Route from 'enum/route.enum';
import EventBus from 'utils/eventBus';
import getIsRTLLanguage from 'utils/common/isRTL';
import Storages from 'storages';
import StorageKeys from 'enum/storages.enum';

class BackCursor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirectBack: false,
      showArrow: false,
      slideArrow: true,
      timeOut: 1 * 1000,
    };
    this._isMounted = false;
    this.subscriptions = {};
  }

  async componentDidMount() {
    this._isMounted = true;
    this.checkPointer();
    this.slideShowArrow();
    this.subscriptions['mouseMoved'] = EventBus.subscribe('mouseMoved', () => {
      clearTimeout(this.state.timeOut);
      this.slideShowArrow();
    });
  }
  componentWillUnmount() {
    this._isMounted = false;
    for (let key in this.subscriptions) {
      this.subscriptions[key]['unsubscribe']();
    }
  }
  slideShowArrow() {
    let { timeOut } = this.state;
    clearTimeout(timeOut);
    if (this._isMounted) {
      this.setState({
        slideArrow: true,
      });

      timeOut = setTimeout(() => {
        if (this._isMounted) {
          this.setState({
            slideArrow: false,
            timeOut,
          });
        }
      }, 3000);
    }
  }
  checkPointer() {
    this.setState({
      showArrow: !matchMedia('(hover: none)').matches,
    });
  }
  goBack() {
    this.setState({
      redirectBack: true,
    });
  }

  render() {
    if (this.state.redirectBack) {
      return <Navigate to={Route.route.LANDING} />;
    }
    let { showArrow, slideArrow } = this.state;
    const isRTL = getIsRTLLanguage();
    return (
      <div style={{ height: 40 }}>
        {showArrow && Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isDEFAULT && (
          <BackArrow
            className={`${slideArrow ? 'is-flex' : 'is-hidden'}`}
            isRTL={isRTL}
          >
            <div className={'is-size-4'} onClick={this.goBack.bind(this)}>
              <span className='icon'>
                <i className={`fa fa-arrow-${isRTL ? 'right' : 'left'}`} aria-hidden='true'></i>
              </span>
            </div>
          </BackArrow>
        )}
      </div>
    );
  }
}

export default BackCursor;
